import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { getValidLink } from 'helpers/fieldsHelpers';
import CustomIcon from 'components/common/CustomIcon';

export const PersonWebPages = ({ webs }) => notEmpty(webs) ? (
    <dl className="dl-horizontal">
        {webs.map((web, index) => (
            <dd key={index} className="break-all">
                <CustomIcon type='doc' /> <a href={getValidLink(web.address)} target="_blank" rel="noopener noreferrer">{web.address}</a> ({web.type})
            </dd>
        ))}
    </dl>
) : null;
